export default __webpack_public_path__ + "static/loginbg-75fd540d15ede922424b8ec24ea1bdbd.png";